// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YfNU1Vm7uXkhgoipnsH0{grid-template-columns:1fr var(--titled-row-action-width,280px);gap:var(--titled-row-horizontal-gap,20px);width:100%;display:grid}.vl9epu6qhs6xirpWXLAD{grid-template-columns:1fr}.ZeZh0uoBE4om4olYpVQn{justify-content:center;gap:var(--titled-row-vertical-gap,4px);flex-direction:column;width:100%;min-width:0;display:flex}.CntWGV_vDOYqJwQkawWD{align-items:center;gap:6px;width:100%;min-width:0;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `YfNU1Vm7uXkhgoipnsH0`,
	"oneColumn": `vl9epu6qhs6xirpWXLAD`,
	"main": `ZeZh0uoBE4om4olYpVQn`,
	"header": `CntWGV_vDOYqJwQkawWD`
};
export default ___CSS_LOADER_EXPORT___;
